import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'

const db = firebase.database()

const environment = {
  schema: {
    cropData: 'crop-data',
    inventory: 'test-inventory',
    marketplace: 'test-marketplace'
  }
}

export const cropData = {
  state: {
    data: {}
  },
  getters: {

  },
  actions: {
    getCropData: firebaseAction(context => {
      let cropDataRef = db.ref(environment.schema.cropData).child(context.rootState.user.groupId)
      context.bindFirebaseRef('data', cropDataRef)
    }),
    detachCropData: firebaseAction(context => {
      try {
        context.unbindFirebaseRef('data')
      } catch (e) {
        // no e
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/crop-data.js